export const jiraExpressionExamples = [
    // Comments
    {
        jiraexp: 'issue.comments.length',
        label: 'Comment count',
        description: 'Example: 5',
    },
    {
        jiraexp: 'issue.comments.length > 0 ? issue.comments[issue.comments.length - 1].created : null',
        label: 'Last comment time',
        description: 'Example: 2024-08-22T10:42:16.110+0200',
    },
    {
        jiraexp: 'issue.comments.length > 0 ? issue.comments[issue.comments.length - 1].created.toString() : null',
        label: 'Last comment time (readable)',
        description: 'Example: 06/Sep/24 10:53 AM',
    },
    {
        jiraexp: 'issue.comments.length > 0 ? issue.comments[issue.comments.length - 1].author.displayName : null',
        label: 'Last comment author',
        description: 'Example: John Doe',
    },

    // Creation Time
    {
        jiraexp: 'issue.created',
        label: 'Creation time',
        description: 'Example: 2024-08-22T10:42:16.110+0200',
    },
    {
        jiraexp: 'issue.created.toString()',
        label: 'Creation time (readable)',
        description: 'Example: 06/Sep/24 10:53 AM',
    },

    // Changelogs
    {
        jiraexp: 'let statusChanges = issue.changelogs.filter(history => history.items.some(item => item.field == \'status\'));if (statusChanges[0] != null) {    if (statusChanges[1] != null) {        let time = (statusChanges[0].created.getTime() - statusChanges[1].created.getTime()) / (1000 * 60 * 60 * 24);    return (time-(time%1));  } else {      let time = (statusChanges[0].created.getTime() - issue.created.getTime()) / (1000 * 60 * 60 * 24);    return (time-(time%1));  }} else {  return 0;}',
        label: 'Days in prev status',
        description: 'Example: 2',
    },
    {
        jiraexp: 'issue.changelogs.filter(history => history.items.some(item => item.field == \'status\')).slice(-1)[0].author.displayName',
        label: 'Last status changer',
        description: 'Example: John Doe',
    },

    // Attachments
    {
        jiraexp: 'issue.attachments.reduce((total, attachment) => total + attachment.size, 0)',
        label: 'Attachment size (bytes)',
        description: 'Example: 2770253905.92',
    },
    {
        jiraexp: 'issue.attachments.reduce((total, attachment) => total + attachment.size, 0)/1024',
        label: 'Attachment size (KB)',
        description: 'Example: 2705326.08',
    },
    {
        jiraexp: 'issue.attachments.reduce((total, attachment) => total + attachment.size, 0)/(1024*1024)',
        label: 'Attachment size (MB)',
        description: 'Example: 2641.92',
    },
    {
        jiraexp: 'issue.attachments.reduce((total, attachment) => total + attachment.size, 0)/(1024*1024*1024)',
        label: 'Attachment size (GB)',
        description: 'Example: 2.58',
    },
    {
        jiraexp: 'issue.attachments.length',
        label: 'Attachment count',
        description: 'Example: 2',
    },

    // Status
    {
        jiraexp: 'issue.status.category.name == \'Done\'',
        label: 'Is Done status',
        description: 'Example: true',
    },

    // Child Issues
    {
        jiraexp: 'issue.childIssues.filter(childIssue => childIssue.status.name == \'Done\').length / issue.childIssues.length * 100',
        label: 'Child issues Done %',
        description: 'Example: 50',
    },

    // Subtasks
    {
        jiraexp: 'issue.subtasks.filter(subtask => subtask.status.name == \'Done\').length',
        label: 'Done sub-tasks',
        description: 'Example: 5',
    },
    {
        jiraexp: 'issue.subtasks.length',
        label: 'Sub-task count',
        description: 'Example: 5',
    },
    {
        jiraexp: 'issue.subtasks.map(subtask => subtask.components.map(component => component.name)).reduce((a, b) => a.concat(b), [])',
        label: 'Sub-task components',
        description: 'Example: Component1, Component2, Component3',
    },

    // Links
    {
        jiraexp: 'issue.links.length',
        label: 'Issue link count',
        description: 'Example: 3',
    },

    // Parent Issue
    {
        jiraexp: 'issue.parent.resolution.name',
        label: 'Parent resolution',
        description: 'Example: Done',
    },
    {
        jiraexp: 'issue.parent.status.category.name',
        label: 'Parent status category',
        description: 'Example: Done',
    },

    // Project
    {
        jiraexp: 'issue.project.projectTypeKey.replace(\'_\',\' \')',
        label: 'Project type',
        description: 'Example: service desk',
    }
];